import React from 'react';

const Navigation = ({ onRouteChange, isSignedIn }) => {
  if (isSignedIn) {
    return (
      <nav
        style={{ display: 'flex', justifyContent: 'flex-end', height: '2.8em' }}
      >
        <p
          onClick={() => onRouteChange('signout')}
          className='f3 link dim black underline pa3 pointer'
        >
          Sign Out
        </p>
      </nav>
    );
  }
};

export default Navigation;
